module.exports = __webpack_public_path__ + "img/f-thermometer-img7-3.e46d4316.jpg";